import React from 'react';
import buildResourcePath from '../../buildResourcePath';

export default class EditorMobileNavigationDrawer extends React.PureComponent {

    renderItem = (item, idx) => {
        const isCompleted = idx < this.props.currentStepIndex;
        let hasIssues = false;

        if (isCompleted) {
            let step = this.props.configurator.getStepsManager().getStepByName(item.slug);
            if (step) {
                hasIssues = step.hasIssues();
            }
        }

        return (
            <div key={idx}
                 className={[
                     'configuration-editor-mobile-step',
                     idx === this.props.currentStepIndex - 1 || idx === this.props.currentStepIndex + 1 ? 'configuration-editor-mobile-step--nearby' : '',
                     idx === this.props.currentStepIndex ? 'configuration-editor-mobile-step--current' : ''
                 ].join(' ')}
            >

                {isCompleted ? (
                    hasIssues ? (
                        <div className="configuration-editor-mobile-step-bubble-error">
                            <img src={buildResourcePath('/assets/icons/warning-white.svg')}/>
                        </div>
                    ) : (
                        <div className="configuration-editor-mobile-step-bubble-success"></div>
                    )
                ) : (
                    <div className="configuration-editor-mobile-step-bubble-unknown"></div>
                )}

                <div>
                    {__('Step')} {idx + 1} / {this.props.availableSteps.length}
                </div>

                <div>
                    {item.name}
                </div>
            </div>
        )
    }

    render() {
        const singleItemHeight = 40;
        const foregroundBarHeight = this.props.currentStepIndex * singleItemHeight;
        const anyIssues = this.props.availableSteps.filter(
            x => {
                const step = this.props.configurator.getStepsManager().getStepByName(x.slug);
                return step && step.hasIssues();
            }
        ).length > 0;

        return (
            <div className={`configuration-editor-mobile-nav-drawer ${this.props.visible ? 'visible' : ''}`}>
                <div className="configuration-editor-mobile-steps">
                    <div className="configuration-editor-mobile-steps-background-bar"></div>

                    {!anyIssues && (
                        <div className="configuration-editor-mobile-steps-foreground-bar"
                             style={{height: foregroundBarHeight + 'px'}}></div>
                    )}

                    {this.props.availableSteps.map(this.renderItem)}
                </div>
            </div>
        )
    }
}